<script>
import Paging from "@/components/Paging.vue";
import ToggleSwitch from "@/components/ToggleSwitch.vue";
import Api from "api-client";

export default {
  name: "Customs",
  components: {Paging, ToggleSwitch},

  data() {
    return {
      result: {},
      searchTerm: "",
      navPopoverContent: '<div><div class="mb-2"><div class="d-inline-block text-center mr-2 pt-2" style="font-size: 18px; background-color: #B2EC5D; border-radius: 50%; padding: 6px; width: 40px; height: 40px;"><i class="fal fa-link"></i></div>NAV összerendelés megtalálható</div></div><div><div class="d-inline-block text-center mr-2 pt-2" style="font-size: 18px; background-color: #F88278; border-radius: 50%; padding: 6px; width: 40px; height: 40px;"><i class="fal fa-link"></i></div>NAV összerendelés hiányzik</div></div>',
      uploadPopoverContent: '<div><div class="mb-2"><div class="d-inline-block text-center mr-2 pt-2" style="font-size: 18px; background-color: #B2EC5D; border-radius: 50%; padding: 6px; width: 40px; height: 40px;"><i class="fal fa-upload"></i></div>Feltöltött fájl megtalálható</div></div><div class="mb-2"><div class="d-inline-block text-center mr-2 pt-2" style="font-size: 18px; background-color: #F88278; border-radius: 50%; padding: 6px; width: 40px; height: 40px;"><i class="fal fa-upload"></i></div>Feltöltött fájl hiányzik</div></div>',
    }
  },
  props: {
    companyId: {
      required: true,
      type: Number,
    }
  },

  methods: {
    doPage(data) {
      this.loadData(data.pagingPage - 1, data.pagingOffset);
    },

    loadData(page, size) {
      Api.getCustoms(
          page,
          size,
          this.companyId,
          this.searchTerm
      )
          .then((resp) => (this.result = resp.data))
          .catch((error) => {
            console.error("API hiba:", error);
            this.$toast.error({
              title: this.$cte("common.error"),
              message: this.$cte("common.error"),
            });
          });
    },

    toggleToBeAccounted(id, value) {
      Api.toggleCustomsToBeAccounted(id, value, this.companyId)
          .then(() => {
            this.loadData(
                this.result.currentPage,
                this.result.pageSize
            )
          })
          .catch((error) => {
            console.error("API hiba:", error);
            this.$toast.error({
              title: this.$cte("common.error"),
              message: this.$cte("common.error"),
            });
          });
    },

    formatAmount(amount) {
      if (amount === null || amount === undefined) {
        return '0';
      }
      return amount.toLocaleString('hu-HU');
    },

    formatDate(dateString) {
      if (!dateString) {
        return '-';
      }
      const date = new Date(dateString);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}.${month}.${day}.`;
    },

    redirectToDetailView(id) {
      this.$router.push("customs/" + id);
    },

    closeAllPopovers(event) {
      if (!event.target.closest('[v-b-popover]')) {
        this.$root.$emit('bv::hide::popover');
      }
    },
  },

  watch: {
    searchTerm() {
      this.loadData(0, 10);
    }
  },

  mounted() {
    this.loadData(0, 10);
    document.addEventListener('click', this.closeAllPopovers, true);
  },

  beforeDestroy() {
    document.removeEventListener('click', this.closeAllPopovers, true);
  },
}
</script>

<template>
  <div class="Customs_vue main-wrapper m-0 p-0 mt-3 font-jumperlight container-fluid">

    <div class="mx-3 mt-2 mb-3">
      <b-form-input
          debounce="600"
          v-model="searchTerm"
          class="white-input d-inline-block align-middle"
          placeholder="Határozatszám"
      ></b-form-input>
    </div>

    <div v-if="result && result.totalNumberOfElements === 0" class="mx-3">
      Nincsenek megjeleníthető adatok
    </div>

    <div v-else class="">

      <div v-for="(item) in result.content"
           :key="item.id"
           class="item-card mb-3"
           :class="item.hasDpSource ? 'item-card-clickable' : ''"
           :style="item.toBeAccounted ? '' : 'opacity: 0.5;'"
           @click="item.hasDpSource ? redirectToDetailView(item.id) : null">
        
        <!-- Row 1: Resolution ID + Paperclip Icon -->
        <div class="card-row row-header">
          <div class="resolution-id font-weight-bold small">
            <span class="text-truncate mr-2">{{ item.resolutionId }}</span>
            <i v-if="item.attachedInvoiceDigestId !== null" class="fal fa-paperclip"></i>
          </div>
        </div>

        <!-- Row 2: Behozatali vám + Import ÁFA -->
        <div class="card-row row-amounts">
          <div class="amount-column vam-column">
            <div class="label text-muted">Behozatali vám</div>
            <div class="value font-weight-bold">{{ formatAmount(item.behozataliVamOsszesen) }} Ft</div>
          </div>
          <div class="amount-column afa-column">
            <div class="label text-muted">Import ÁFA</div>
            <div class="value font-weight-bold">{{ formatAmount(item.totalVatAmount) }} Ft</div>
          </div>
        </div>

        <!-- Row 3: Kézbesítés dátuma -->
        <div class="card-row row-date">
          <div class="date-column">
            <div class="label text-muted">Kézbesités dátuma</div>
            <div class="date-value font-weight-bold">{{ formatDate(item.deliveryDate) }}</div>
          </div>
        </div>

        <!-- Row 4: Icons + Elszámolom Toggle -->
        <div class="card-row row-toggle-icons">
          <!-- Icons -->
          <div class="icons-wrapper">
            <!-- NAV Source Icon -->
            <div class="icon-circle"
                 :class="item.hasNavSource ? 'bgGreen' : 'bgRed'">
              <button v-b-popover.html.top.click="navPopoverContent"
                      class="btn btn-transparent p-0 m-0"
                      @click.stop>
                <i class="fal fa-link"></i>
              </button>
            </div>

            <!-- DP Source Icon -->
            <div class="icon-circle"
                 :class="item.hasDpSource ? 'bgGreen' : 'bgRed'">
              <button v-b-popover.html.top.click="uploadPopoverContent"
                      class="btn btn-transparent p-0 m-0"
                      @click.stop>
                <i class="fal fa-upload"></i>
              </button>
            </div>
          </div>

          <!-- Toggle -->
          <div class="toggle-wrapper">
            <span class="toggle-label">Elszámolom</span>
            <ToggleSwitch v-model="item.toBeAccounted"
                          @change="() => toggleToBeAccounted(item.id, item.toBeAccounted)"
                          @click.native.stop/>
          </div>
        </div>
      </div>
    </div>

    <paging
        v-if="result.totalNumberOfElements > 0"
        :item-per-page="result.pageSize"
        :total-rows="result.totalNumberOfElements"
        @paging-change="doPage"
    />

  </div>
</template>

<style scoped>
.main-wrapper {
  background-color: white;
  padding: 15px;
  border-radius: 5px;
}

.bgGreen {
  background-color: #B2EC5D !important;
}

.bgRed {
  background-color: #F88278 !important;
}

.bgGrey {
  background-color: #E5EAEE !important;
}

button:focus {
  outline: none !important;
  box-shadow: none !important;
}

.popover {
  max-width: 350px !important;
  width: 450px !important;
  border-radius: 32px !important;
  padding: 14px;
}

.text-truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* Card Base Styles */
.item-card {
  background-color: #C8D5DA;
  border-radius: 36px;
  padding: 16px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transition: all 0.2s ease;
}

.item-card-clickable {
  cursor: pointer;
}

.item-card-clickable:hover {
  transform: translateX(-10px);
  margin-right: -10px;
}

/* Card Rows */
.card-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

/* Row 1: Header - Resolution ID + Paperclip */
.row-header {
  margin-bottom: 12px;
}

.resolution-id {
  font-size: 11px;
  color: #333;
}

.paperclip-icon {
  font-size: 18px;
  color: #666;
}

/* Row 2: Amounts */
.row-amounts {
  margin-bottom: 12px;
}

.amount-column {
  flex: 1;
}

.amount-column .label {
  font-size: 11px;
  margin-bottom: 2px;
}

.amount-column .value {
  font-size: 20px;
  color: #333;
}

/* Row 3: Date */
.row-date {
  margin-bottom: 12px;
}

.date-column .label {
  font-size: 11px;
  margin-bottom: 2px;
}

.date-value {
  font-size: 13px;
  color: #333;
}

/* Row 4: Icons + Toggle */
.row-toggle-icons {
  justify-content: space-between;
  align-items: center;
}

.icons-wrapper {
  display: flex;
  gap: 10px;
}

.icon-circle {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  font-size: 16px;
}

.icon-circle button {
  color: inherit;
}

.icon-circle i {
  color: #333;
}

.toggle-wrapper {
  display: flex;
  align-items: center;
  gap: 12px;
}

.toggle-label {
  font-size: 12px;
  color: #333;
}

/* Desktop Styles (992px and up) */
@media (min-width: 992px) {
  .item-card {
    background-color: #AEC0C7;
    border-radius: 36px;
    padding: 12px 24px;
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
  }

  .card-row {
    display: contents;
  }

  .row-header {
    flex: 0 0 auto;
    width: 16%;
    margin-bottom: 0;
    display: flex;
    align-items: center;
  }

  .row-amounts {
    flex: 0 0 auto;
    width: 33%;
    display: flex;
    margin-bottom: 0;
  }

  .amount-column {
    flex: 1;
  }

  .amount-column .value {
    font-size: 16px;
  }

  .row-date {
    flex: 0 0 auto;
    width: 17%;
    margin-bottom: 0;
  }

  .row-toggle-icons {
    flex: 0 0 auto;
    width: 34%;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 24px;
  }
}
</style>
